import { FC, useState, useCallback } from 'react';
import { feedService } from '@/services/feed.service';

interface FollowButtonProps {
  userId: string;
  initialIsFollowing?: boolean;
  onFollowChange?: (isFollowing: boolean) => void;
}

const FollowButton: FC<FollowButtonProps> = ({
  userId,
  initialIsFollowing = false,
  onFollowChange,
}) => {
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggle = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isLoading) return;

    setIsLoading(true);
    try {
      if (isFollowing) {
        await feedService.unfollow(userId);
        setIsFollowing(false);
        onFollowChange?.(false);
      } else {
        await feedService.follow(userId);
        setIsFollowing(true);
        onFollowChange?.(true);
      }
    } catch (error) {
      console.error('Erro ao alterar follow:', error);
    } finally {
      setIsLoading(false);
    }
  }, [userId, isFollowing, isLoading, onFollowChange]);

  return (
    <button
      onClick={handleToggle}
      disabled={isLoading}
      data-testid="follow-button"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all disabled:opacity-50 ${
        isFollowing
          ? 'bg-accent text-accent-contrast hover:bg-red-500'
          : 'border border-accent text-accent hover:bg-accent hover:text-accent-contrast'
      }`}
    >
      {isLoading ? (
        <span className="material-symbols-outlined text-sm animate-spin">progress_activity</span>
      ) : (
        <span className="material-symbols-outlined text-sm">
          {isFollowing ? 'person_remove' : 'person_add'}
        </span>
      )}
      {isFollowing ? 'Seguindo' : 'Seguir'}
    </button>
  );
};

export default FollowButton;
